import {ReactElement} from "react";
import {GetDataApi} from "../../components/types/GetDataApi";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import formatDateTime from "../../components/TimeFormat";
import {useGetAuditEventsByRequestId, useGetAuditRequestByRequestId} from "../../application/AuditService";
import {AuditRequest} from "../../domain/audit/AuditRequest";
import AuditEventComponent from "../../components/AuditEventComponent";
import {AuditEvent} from "../../domain/audit/AuditEvent";

export default function AuditRequestPage(): ReactElement {
    const auditRequest: GetDataApi<AuditRequest> = useGetAuditRequestByRequestId();
    const auditEvent: GetDataApi<AuditEvent[]> = useGetAuditEventsByRequestId();


    const getUrlOrInfo = () => {
        if (auditRequest.data.verb) {
            return auditRequest.data.verb + " " + auditRequest.data.url;
        }
        return auditRequest.data.url;
    }

    if (auditRequest.loading) {
        return (<></>);
    } else {
        return (
            <Container maxWidth={false} sx={{mt: 4, mb: 4, px: 2}}>
                {<Toolbar/>}
                <Grid container spacing={2} sx={{ height: 1000 }}>
                    <Grid size={{ xs: 12 }}>
                        <Title>Audit Request {auditRequest.data.requestId} </Title>
                    </Grid>
                    <Grid container size={{ xs: 12 }} sx={{ border: 2, borderRadius: "6px", borderColor: "primary.main", mb: 2 }}>
                        <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>User</Grid>
                        <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>{auditRequest.data.user}</Grid>
                        <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>Event Time</Grid>
                        <Grid size={{ xs: 4 }} sx={{ padding: 1 }}> {formatDateTime(auditRequest.data.eventTime)}</Grid>
                        <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>Type</Grid>
                        <Grid size={{ xs: 4 }} sx={{ padding: 1 }}> { auditRequest.data.type }</Grid>
                        <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>URL/Info</Grid>
                        <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>{ getUrlOrInfo() }</Grid>
                        <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>Source</Grid>
                        <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>{ auditRequest.data.source }</Grid>
                        <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>External Id</Grid>
                        <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>{ auditRequest.data.externalId }</Grid>
                    </Grid>
                    <Grid container size={{ xs: 12 }} sx={{ border: 2, borderRadius: "6px", borderColor: "primary.main" }}>
                        <AuditEventComponent data={auditEvent.data} loading={auditEvent.loading}/>
                    </Grid>
                </Grid>
            </Container>
        );
    }
}